module.exports = __webpack_public_path__ + "96374f612fd40cb0da8cc1814e818478.woff";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-overpass-mono/files/overpass-mono-latin-600.woff
// module id = 171
// module chunks = 1